module.exports = __webpack_public_path__ + "img/2022_09_dandelion_shiyakusyo_fin_web.07438471.jpg";